import React from 'react';
import { useLanguage } from './LanguageContext';
export const Navbar = () => {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className="w-full z-40 bg-brand-black border-b border-white/10 py-4" data-id="element-570">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-571">
        <div className="flex justify-between items-center" data-id="element-572">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-573">
            <img src="https://cdn.magicpatterns.com/uploads/uJZrGhTzMnY7pLTJd1VGay/IMG_4659.jpg" alt="Move Fighters Logo" className="h-12 w-auto object-contain rounded-md" data-id="element-574" />
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-575">
            <button onClick={() => scrollToSection('packages')} className="text-white hover:text-brand-red transition-colors font-medium text-sm tracking-wide uppercase" data-id="element-576">
              {t.nav.packages}
            </button>
            <button onClick={() => scrollToSection('coverage')} className="text-white hover:text-brand-red transition-colors font-medium text-sm tracking-wide uppercase" data-id="element-577">
              {t.nav.coverage}
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-white hover:text-brand-red transition-colors font-medium text-sm tracking-wide uppercase" data-id="element-578">
              {t.nav.howItWorks}
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-white hover:text-brand-red transition-colors font-medium text-sm tracking-wide uppercase" data-id="element-579">
              {t.nav.faq}
            </button>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-4" data-id="element-580">
            <div className="flex items-center bg-white/10 rounded-full p-0.5" data-id="element-581">
              <button onClick={() => setLanguage('en')} className={`px-3 py-1.5 rounded-full text-xs font-bold tracking-wider transition-all ${language === 'en' ? 'bg-brand-red text-white' : 'text-gray-400 hover:text-white'}`} data-id="element-582">
                EN
              </button>
              <button onClick={() => setLanguage('es')} className={`px-3 py-1.5 rounded-full text-xs font-bold tracking-wider transition-all ${language === 'es' ? 'bg-brand-red text-white' : 'text-gray-400 hover:text-white'}`} data-id="element-583">
                ES
              </button>
            </div>

            <button onClick={() => scrollToSection('packages')} className="hidden sm:block bg-brand-red hover:bg-brand-darkred text-white px-6 py-2.5 rounded font-oswald font-bold tracking-wider uppercase transition-all transform hover:scale-105 active:scale-95" data-id="element-584">
              {t.nav.cta}
            </button>
          </div>
        </div>
      </div>
    </nav>;
};